import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { range } from '../../helpers/range';
import { RequestsComponent } from '../requests/requests.component';
import { ActivatedRoute, Router } from '@angular/router';
import { delay, startWith, switchMap, tap, filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent extends RequestsComponent implements OnInit, OnDestroy {

  page: number = 1;
  count: number;

  @Input() size: number = 12;
  @Input() resource: string;
  @Input() service: any;
  @Input() endpoint: string = 'fetch';
  @Input() extras: any = {};

  @Output() resources: EventEmitter<any> = new EventEmitter();
  @Output() count_emitter: EventEmitter<any> = new EventEmitter();
  @Output() showing_emitter: EventEmitter<any> = new EventEmitter();


  pages: number[] = [];
  start: number;
  finish: number;
  params: any;
  loading: boolean;

  // tslint:disable-next-line:variable-name
  showing_all: boolean;
  routeSubscription: Subscription

  constructor(
    private route: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit() {
    try {
      this.routeSubscription = this.route.params.pipe(
        startWith(null),
        delay(0),
        switchMap(params => {
          // this.params = params;
          return this.route.queryParams;
        }),
        tap(queryParams => {
          if (this.params !== null) {
            const request = { ...this.params, ...queryParams, ...this.extras };
            if (queryParams.search === 'false' || !queryParams.search) {
              this.fetchResource(request);
            }
          }
        })
      ).subscribe();
    } catch {
    }
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe()
  }

  public reload() {
    window.location.reload();
    /* if (this.page > 1) {
      this.page = 1;
      this.fetch();
    } else {
      window.location.reload();
    } */
  }

  private fetch() {
    setTimeout(() => {
      const page = this.page;
      const size = this.size;
      this.router.navigate([], { queryParams: { page, size, search: false }, queryParamsHandling: 'merge' });
    }, 0);
  }

  private fetchResource(params: any) {
    if (params.page === undefined) {
      params.page = this.page;
    }
    if (params.size === undefined) {
      params.size = this.size;
    }
    this.loading = true;
    this.invokedHttpRequests.push(
      this.service[this.endpoint](params, true).subscribe(
        (resp: any) => this.load(resp),
        () => this.loading = false
      )
    );
  }

  public load(resp: any) {
    this.loading = false;
    this.page = resp.page;
    this.count = resp.count;
    this.size = resp.page_size;
    this.resources.emit(resp.data);
    this.count_emitter.emit(resp.count);
    this.paginate();
  }

  goto(page: number) {
    this.page = page;
    this.fetch();
  }

  prev() {
    if (this.page - 1 > 0) {
      this.page--;
      this.fetch();
    }
  }

  next() {
    if (this.page + 1 <= this.pages.length) {
      this.page++;
      this.fetch();
    }
  }

  private paginate() {
    if (this.page === 1 && this.count < this.size) {
      this.showing_all = true;
      return;
    } else {
      this.showing_all = false;
    }
    this.start = (this.page - 1) * this.size + 1;
    const finish = this.page * this.size;
    this.finish = finish > this.count ? this.count : finish;
    const pages = Math.ceil(this.count / this.size);
    if (pages > 1) {
      this.pages = range(1, pages); // +1
    }
    this.showing_emitter.emit(`${this.start} - ${this.finish} of ${this.count} ${this.resource}`);

  }

  getPageList(totalPages: number, page: number, maxLength: number) {

    if (maxLength < 5) return;

    const sideWidth = maxLength < 9 ? 1 : 2;
    const leftWidth = (maxLength - sideWidth * 2 - 3) >> 1;
    const rightWidth = (maxLength - sideWidth * 2 - 2) >> 1;
    if (totalPages <= maxLength) {
      // no breaks in list
      return range(1, totalPages);
    }
    if (page <= maxLength - sideWidth - 1 - rightWidth) {
      // no break on left of page
      return range(1, maxLength - sideWidth - 1)
        .concat(0, range(totalPages - sideWidth + 1, totalPages));
    }
    if (page >= totalPages - sideWidth - 1 - rightWidth) {
      // no break on right of page
      return range(1, sideWidth)
        .concat(0, range(totalPages - sideWidth - 1 - rightWidth - leftWidth, totalPages));
    }
    // Breaks on both sides
    return range(1, sideWidth)
      .concat(0, range(page - leftWidth, page + rightWidth),
        0, range(totalPages - sideWidth + 1, totalPages));
  }

}
